import lazyImporter from '@/utils/lazyImporter'

const bookTagRoute = {
  component: lazyImporter('View'),
  meta: { title: 'bookTags', icon: 'event', hidden: true },
  name: 'admin_book_tag',
  path: '/book-tag',
  redirect: { name: 'admin_book_tag_list' },
  children: [
    {
      component: lazyImporter('bookTag/BookTagList'),
      meta: { title: 'bookTagList', hidden: true },
      name: 'admin_book_tag_list',
      path: ''
    },
    {
      component: lazyImporter('bookTag/BookTagUpdate'),
      meta: { title: 'bookTagUpdate', hidden: true },
      name: 'admin_book_tag_update',
      path: ':slug/update',
      props: true
    },
    {
      component: lazyImporter('bookTag/BookTagAdd'),
      meta: { title: 'bookTagAdd', hidden: true },
      name: 'admin_book_tag_add',
      path: 'add'
    }
  ]
}

export default bookTagRoute
